import { format } from "date-fns";
import { marked } from "marked";
import React, { useEffect, useRef, useState } from "react";
import "react-datetime/css/react-datetime.css";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import api from "../../../../../../../api/api";
import { checkifDateisAfterToday } from "../../../../../../../utils/validator";
import "../../../../../styles/dashboard.css";
import "../../../../../styles/lesson.css";
import "../../../../../styles/responsive_lesson.css";
import AOS from "aos";
import "aos/dist/aos.css";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { updateGlobalState } from "../../../../../../../state/global/slice.tsx";
import { AssignmentType } from "../../../../../../../utils/consts.js";
import "../../../../editor/css/styles.css";
import { Ring } from "@uiball/loaders";
import PreprocessAndRenderLatex from "../../../../../../../components/ProcessRenderLatex";
import UniversalChatbot from "../../../../../../../components/universalChatbot/UniversalChatbot.js";
import "../../../../../../speechtotext/SpeechtoText.css";
import { resetLessonAudio } from "../../../../../../../state/actions/getLessonAudioSocketAction";
import {
  setcourseCheckPublishtoSchoologydtls,
  resetCourseCheckPublishtoSchoology,
} from "../../../../../../../state/actions/courseCheckPublishtoSchoologyAction.ts";
import { resetReFormatter } from "../../../../../../../state/actions/reFormatterAction";
import { processLatex } from "../../../../../../../utils/PreProcessorLatexCode.js";
import {
  extractYoutubeUrlFromHtml,
  normalizeLatexToDoubleDollar,
} from "./utils/fileHelpers.js";
import { useNewLessons } from "./NewLessonContext.js";
import LessonGenerator from "./LessonGenerator/LessonGenerator.jsx";
import FloatingAIButton from "../../../../../../../components/FloatingAIButton/FloatingAIButton.jsx";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
  setAgentData,
  setInitialProjectId,
} from "../../../../../../../state/reducers/chatDrawerReducers.ts";

const NewLessonsEntry = () => {
  const {
    room_id,
    setRoom_id,
    lesson,
    setLesson,
    formState,
    setFormState,
    setFormLessonErrorState,
    setChatHist,
    setIsChatHistLoading,
    formAssignmentState,
    setFormAssignmentState,
    lesson_id,
    setlesson_id,
    setAssignmentgeneration,
    setWorkboardText,
    activeWorkboard,
    setActiveWorkboard,
    workboards,
    rubrics,
    setRubrics,
    isAssignment,
    setIsAssignment,
    isRubric,
    setIsRubric,
    setPopupVisible,
    isSwitchOn,
    setShowPopup,
    assignmentDurationCount,
    isListening,
    transcript,
    startStopListening,
    openStudentView,
    previewDtls,
    token,
    eachAssignment_id,
    defaultWorkboardData,
    globleSaveData,
    getassignmentdetails,
    assignmentsCountTwo,
    setisSaveChecker,
    setShowCourseSuccessfully,
    setLoadingPublishSchoology,
    updateDefaultWorkboardData,
    setPreviesAssignment,
    setEachAssignment_id,
    setassignment_id,
    setrubric_id,
    setGlobleSaveData,
    setswitchschoologySync,
    istoggleClick,
    setGetAssignmentdetails,
    setAssignmentCountsTwo,
    setopenStudentView,
    setAssignmentCounts,
    setSelectedAssignment,
    setOnChangeAssignmentData,
    setRubricCount,
    setOnChangeRubricData,
    setSelectedRubric,
    updateWorkboardDataByName,
    globleOnChange,
    setGlobleOnChange,
    showRubricPopUp,
    showDownloadFile,
    modalContentRef,
    toggledownlodefile,
    setschoologystatus,
    setshowloading,
    handleForm1Submit,
    showPopUp,
    setShowPopUp,
    location,
    adminRole,
    chatDrawerState,
    registerGenerateAllRefetchCallbacks,
    setCallAddAssignmentFun,
    setGetSavedYoutubeLinks,
    socketDisconnected,
    setSocketDisconnected,
  } = useNewLessons();

  const getassignmentdetailsRef = useRef(getassignmentdetails);
  getassignmentdetailsRef.current = getassignmentdetails;

  const GENERATE_LESSON_DESCRIPTION_PLACEHOLDER = "@$%^231#^#a5fgd%532^&4R3&";
  const GENERATE_LESSON_DESCRIPTION_PLACEHOLDER_TWO =
    "@$%^231#^#a5fgd%532^&amp;4R3&amp;";
  const isGenerateLessonDescriptionPlaceholder =
    GENERATE_LESSON_DESCRIPTION_PLACEHOLDER_TWO === previewDtls ||
    GENERATE_LESSON_DESCRIPTION_PLACEHOLDER === previewDtls;
  const EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two =
    "This lesson was skipped to directly create an assignment.";
  const course = location.state?.course || {};

  const { message, isLoading, error } = useSelector(
    (state) => state.courseCheckPublishtoSchoology,
  );
  const dispatch = useDispatch();
  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const [loadingPopUp, setLoadingPopUp] = useState(false);
  const [assignmentMsg, setAssignmentMsg] = useState(false);

  const previewYoutubeIframeRef = useRef(null);
  const previewBodyRef = useRef(null);

  useEffect(() => {
    // When the assignment changes, persist the toggle state
    const assignment = getassignmentdetails[assignmentsCountTwo];
    if (assignment && assignment?.synced_with_schoology !== undefined) {
      setswitchschoologySync(assignment.synced_with_schoology);
    }
    if (assignment?.synced_with_schoology == undefined) {
      setswitchschoologySync(false);
    }
  }, [assignmentsCountTwo, getassignmentdetails]);

  useEffect(() => {
    if (socketDisconnected && lesson?.lesson_id) {
      getChatHistory(lesson?.lesson_id);
      setSocketDisconnected(false);
    }
  }, [socketDisconnected, lesson?.lesson_id]);

  // extract iframe src + strip it from the preview HTML
  const { previewCleanHtml, previewYtSrc } = React.useMemo(() => {
    const raw = normalizeLatexToDoubleDollar(previewDtls) || "";
    if (!raw) return { previewCleanHtml: "", previewYtSrc: "" };

    let src = "";
    let cleanHtml = raw;
    try {
      const doc = new DOMParser().parseFromString(raw, "text/html");
      const iframe = doc.querySelector('iframe[src*="youtube.com/embed/"]');
      if (iframe) {
        src = iframe.getAttribute("src") || "";
        iframe.remove(); // remove so it doesn't render inline / twice
      }
      cleanHtml = doc.body.innerHTML;
    } catch (e) {
      cleanHtml = raw;
    }

    return { previewCleanHtml: cleanHtml, previewYtSrc: src };
  }, [previewDtls]);

  // ensure enablejsapi=1 so postMessage seeking works
  const previewYoutubeEmbedSrc = React.useMemo(() => {
    if (!previewYtSrc) return "";
    try {
      const u = new URL(previewYtSrc);
      u.searchParams.set("enablejsapi", "1");
      return u.toString();
    } catch {
      return previewYtSrc;
    }
  }, [previewYtSrc]);

  useEffect(() => {
    if (message) {
      setisSaveChecker(false);

      if (message?.new_assignment) {
        setShowPopUp(false);
      }
      let schoologystatus = "syncDone";
      if (lesson_id !== "") {
        setLoadingPublishSchoology(true);
        setShowPopUp(false);
        setschoologystatus(schoologystatus);
        // handleAssinmentRubricSubmit(null, schoologystatus);
        if (schoologystatus === "" || schoologystatus === "syncDone") {
          setShowCourseSuccessfully(true);

          // Set a timeout to hide the success message after 2 seconds
          setTimeout(() => {
            setShowCourseSuccessfully(false); // Set it to false after 2 seconds
          }, 2000);

          setLoadingPublishSchoology(false);
          //setshowloading(true)
        }
      } else {
        handleForm1Submit(null, schoologystatus);
        setschoologystatus(schoologystatus);
        //setshowloading(true)
      }
      setshowloading(false); //bb
    } else if (error) {
      setshowloading(false);
      if (error?.status === 403) {
        toast.error(error?.message);
        setswitchschoologySync(false);
        return;
      }

      setAssignmentMsg(error?.create_course);
      if (error.status === 404) {
        setShowPopUp(true);
      } else {
        setShowPopUp(false);
        dispatch(resetCourseCheckPublishtoSchoology());
        setisSaveChecker(false);
      }
    } else {
      setisSaveChecker(false);
    }
    return () => {
      dispatch(resetCourseCheckPublishtoSchoology());
      setisSaveChecker(false);
    };
  }, [message, error]);

  // ── timestamp helpers (same as OverviewLesson) ───────────────────────────
  const timestampToSeconds = (text) => {
    if (!text) return 0;
    const clean = String(text).trim();
    if (/^\d+$/.test(clean)) return parseInt(clean, 10);
    const parts = clean.split(":").map((p) => parseInt(p, 10));
    if (parts.some((p) => Number.isNaN(p))) return 0;
    if (parts.length === 2) return parts[0] * 60 + parts[1];
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    return 0;
  };

  const getSecondsFromButton = (btn) => {
    const url = btn.getAttribute("data-url") || "";
    const m = url.match(/[?&](?:t|start)=(\d+)/);
    if (m) return parseInt(m[1], 10);
    return timestampToSeconds((btn.textContent || "").trim());
  };

  const seekYoutube = (iframe, seconds) => {
    if (!iframe || !iframe.contentWindow) return false;
    try {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: "command",
          func: "seekTo",
          args: [seconds, true],
        }),
        "*",
      );
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "playVideo", args: [] }),
        "*",
      );
      return true;
    } catch (e) {
      return false;
    }
  };

  // delegate timestamp-button clicks inside the preview modal to the iframe
  useEffect(() => {
    if (!openStudentView) return; // modal must be mounted
    const container = previewBodyRef.current;
    if (!container) return;

    const onClick = (e) => {
      const btn = e.target.closest(".youtube_timestamp");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const seconds = getSecondsFromButton(btn);
      const iframe = previewYoutubeIframeRef.current;

      const ok = seekYoutube(iframe, seconds);
      if (!ok && iframe) {
        try {
          const u = new URL(iframe.src);
          u.searchParams.set("enablejsapi", "1");
          u.searchParams.set("start", String(seconds));
          u.searchParams.set("autoplay", "1");
          iframe.src = u.toString();
        } catch (err) {
          console.error("timestamp reload fallback failed:", err);
        }
      }
      iframe?.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    container.addEventListener("click", onClick);
    return () => container.removeEventListener("click", onClick);
  }, [openStudentView, previewCleanHtml]);

  const handleYesClick = async () => {
    setLoadingPublishSchoology(true); // Start loading animation
    setLoadingPopUp(true); // Start loader

    const req = {
      assignment_id: eachAssignment_id,
      toggle: true,
      ...(assignmentMsg
        ? { create_course: true, create_assignment: true }
        : { create_assignment: true }),
    };

    try {
      // Resend the request with create_course: true
      await dispatch(setcourseCheckPublishtoSchoologydtls(req, token));
      setShowPopUp(false); // Close the pop-up after successful API call
      setLoadingPublishSchoology(false); // Stop loading
      setLoadingPopUp(false); // Start loader
    } catch (error) {
      console.error("Error creating course on Schoology:", error);
      setLoadingPublishSchoology(false); // Stop loading in case of error
      setLoadingPopUp(false);
    }
  };

  const handleNoClick = () => {
    setShowPopUp(false); // Close the pop-up
    setLoadingPublishSchoology(false); // Stop loading
    setswitchschoologySync(false);

    setGetAssignmentdetails((prevAssignments) => {
      return prevAssignments.map((assignment, index) => {
        if (index === assignmentsCountTwo) {
          // If this is the assignment we're updating, set `synced_with_schoology` to false
          return { ...assignment, synced_with_schoology: false };
        }
        // Return the original assignment if it's not the one we're updating
        return assignment;
      });
    });
  };

  const navigate = useNavigate();
  const getAssignmentTypeName = (type) => {
    return Object.values(AssignmentType).find((item) => {
      return item.value === type;
    })?.name;
  };

  useEffect(() => {
    if (location.state === null) {
      navigate("/dashboard/home");
      return;
    }
    if (location.state.openFirstAssignment) {
      sessionStorage.setItem("skipLesson", "true");
    }
    const lesson = location.state.lesson;
    const hasLessonValues =
      lesson &&
      typeof lesson === "object" &&
      !Array.isArray(lesson) &&
      Object.keys(lesson).length > 0;
    if (hasLessonValues) {
      sessionStorage.setItem("lesson_name", JSON.stringify(lesson.name));
    }
  }, [location]);

  const [voices, setVoices] = useState([]);
  useEffect(() => {
    const voice = speechSynthesis.getVoices();
    if (Array.isArray(voice) && voice.length > 0) {
      setVoices(voice);
      return;
    }
    if ("onvoiceschanged" in speechSynthesis) {
      speechSynthesis.onvoiceschanged = function () {
        const voice = speechSynthesis.getVoices();
        setVoices(voice);
      };
    }
    getAssignment(lesson?.lesson_id);
  }, []);

  const createChatRoom = async (user_id) => {
    const payload = {
      user_id: user_id,
      against_user_id: user_id,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    try {
      const response = await api.post(
        `ai/api/lesson_create_chat_room/`,
        payload,
        headers,
      );
      if (response.status === 200 || response.status === 201) {
        setRoom_id(response?.data?.room_id);
        sessionStorage.setItem("roomId", response?.data?.room_id);
        return response?.data?.room_id;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  };
  const getChatHistorybyRoomid = (roomid) => {
    const payload = {
      room_id: roomid,
    };
    const url = `ai/api/get-chat-history-by-room-id/`;
    callchathistfunction(url, payload);
  };
  const getChatHistory = (lessonId) => {
    const payload = {
      lesson_id: lessonId,
    };
    const url = `ai/api/lesson_chat_history/`;
    callchathistfunction(url, payload);
  };

  const callchathistfunction = async (url, payload) => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    };
    setIsChatHistLoading(true);
    try {
      const response = await api.post(url, payload, headers);

      if (response.status !== 200 && response.status !== 201) {
        toast.error("Failed to load lesson history");
        return;
      }

      const historiesData = response?.data?.data?.histories;
      if (!historiesData || !Array.isArray(historiesData)) {
        toast.error("Invalid response structure");
        return;
      }

      const demo = [
        {
          "uuid": 727584,
          "query": "generate a lesson ",
          "answer": "# Designing a CI/CD Workflow Automation Platform: From GitHub Actions Pipelines to Distributed System Architecture\n\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/y7S2oSjJ8PA\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen></iframe>\n\n<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/nKUe1ML_zhE\" title=\"YouTube video player\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" referrerpolicy=\"strict-origin-when-cross-origin\" allowfullscreen></iframe>\n\n**Course Context:** Software Engineering / Computer Science\n**Grade Range:** High School (Grades 11–12) / Advanced CS Elective\n**NJSLS Alignment:** 8.1.12.CS.1 (Computing Systems), 8.1.12.CS.2 (Hardware & Software Interaction), 8.1.12.DA.1 (Data Collection & Storage), 8.2.12.ED.3 (Engineering Design — iterative refinement), 8.1.12.AP.1 (Algorithms & Programming)\n\n---\n\n## Lesson Overview\n\nThis lesson has two halves that teach the same subject at two different altitudes.\n\nIn the **first half**, you build a real continuous integration and continuous deployment pipeline by hand: you write a small Node.js application, containerize it with Docker, push it to a remote repository, buy and configure a server, and then automate the entire deployment with GitHub Actions. You will see exactly which manual steps the automation replaces — and *why* a human repeating those steps is the problem being solved.\n\nIn the **second half**, you flip to the other side of the table and design the platform itself. If GitHub Actions runs 50 million workflow executions a day for millions of untrusted users, what does the data model behind it look like? How do you model job dependencies? How do you keep one customer's code from attacking another's? This is the system design interview version of the same topic.\n\n### Learning Objectives\n\nBy the end of this lesson you will be able to:\n\n1. Explain the manual deployment workflow and identify precisely which steps are repetitive and automatable.\n2. Write a Dockerfile and a Docker Compose file for a Node.js Express application.\n3. Author a GitHub Actions workflow YAML file with triggers, jobs, runners, and steps.\n4. Generate an SSH key pair and configure repository secrets for secure, automated server access.\n5. Model workflow automation data using a polyglot persistence architecture (relational, message broker, key-value, object store, search index).\n6. Represent job dependencies as a Directed Acyclic Graph (DAG) and compute in-degree state for scheduling.\n7. Describe tenant isolation techniques for executing untrusted code safely.\n8. Explain real-time log streaming through a fan-out architecture.\n\n---\n\n## Part 1 — The Deployment Problem <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=41\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">00:41</button>\n\n### The Starting Situation\n\nPicture yourself as a developer. On your local laptop you have some Node.js code — JavaScript running on your own machine. What you want to do is get that code running on a server somewhere so the rest of the world can reach it.\n\nSo you need two things: your local machine with the code, and a server to deploy it onto.\n\n### Approach One: Copy and Paste (Don't Do This)\n\nThe simplest conceivable approach is:\n\n1. SSH into the server. <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=36ENBdVzBjUaZMwK&t=50\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">00:50</button> \n2. Copy the code from your laptop.\n3. Paste it onto the server.\n\nThis is \"not at all a good way.\" Nobody does this, and for good reason — there's no history, no versioning, no way to roll back, and no way for a teammate to reproduce what you did.\n\n### Approach Two: Version Control as the Transport Layer\n\nWhat developers actually do is route the code through a hosted version control system — GitHub, GitLab, or anything equivalent.\n\nThe flow becomes:\n\n1. **Push** your code from your laptop up to the Git repository.\n2. **SSH** into your server.\n3. **Pull** the latest code from the repository down onto the server.\n4. **Run** the code — with Docker Compose or whatever runner tool you use.\n\nThat's the whole deployment. Four steps.\n\n### Why This Is Still Broken\n\nHere is the problem: **these are all manual steps.** Every single time you push anything, you have to repeat all of these steps, in exactly the same order, by hand.\n\nTwo failure modes compound here:\n- The process is manual, so it is error-prone.\n- The process must be repeated forever, so the cost never goes away.\n\n**This is exactly where CI/CD enters the picture.**\n\n### Worked Reasoning — Counting the Cost\n\nLet's quantify why automation matters. Suppose a small team ships 8 deployments per day, and the manual SSH-pull-rebuild sequence takes a careful developer 4 minutes of focused attention.\n\n$$\\text{Daily cost} = 8 \\times 4 = 32 \\text{ minutes}$$\n\n$$\\text{Annual cost} = 32 \\times 250 = 8{,}000 \\text{ minutes} \\approx 133 \\text{ hours}$$\n\nThat is over three full work weeks of a developer doing nothing but typing the same four commands. And that figure assumes zero mistakes — no forgotten `git pull`, no rebuild skipped, no deployment to the wrong directory.\n\n### Concept Check\n\n1. Why is pushing code to GitHub and pulling it down on the server better than directly copying files, even though both end with the same files on the server?\n2. Of the four manual steps listed above, which one requires a human decision, and which three are purely mechanical?\n3. In your own words, what specific problem does CI/CD solve? (Hint: it is not \"deploying\" — deploying already worked.)\n\n---\n\n## Part 2 — What GitHub Actions Actually Is <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=227\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">03:47</button>\n\nGitHub Actions is a feature built into GitHub. The mental model is simple: **you give it a set of instructions, written in plain YAML, and it carries them out on your behalf every time you push.**\n\n### Writing the Instructions in Plain English First\n\nBefore writing any YAML, state the instruction in ordinary language. This is a genuinely useful technique — say it in words, then translate it to code:\n\n> Whenever there is a push:\n> - SSH into my server\n> - `cd` to wherever my code lives — say, `/home/app`\n> - Run `git pull`\n> - Run `docker compose up -d`\n>\n> Done. There are no other steps besides these.\n\nThat is the entire deployment logic. Once that is expressed as a YAML file, GitHub Actions can run it.\n\n### Where Does It Run? Runners.\n\nInside GitHub there is something known as **runners**. These are GitHub's own servers. Your script executes on a runner, and from that runner it reaches out to *your* server and executes all the steps there.\n\nSo the complete developer experience collapses to:\n\n1. Write code.\n2. Push to GitHub.\n3. **That's it.** GitHub takes care of everything else.\n\n### Concept Check\n\n1. What file format do you write GitHub Actions instructions in?\n2. Where does the workflow script physically execute — on your laptop, on GitHub's infrastructure, or on your deployment server?\n3. If the script runs on GitHub's runner, what does the runner need in order to reach *your* server?\n\n---\n\n## Part 3 — Building the Node.js Application <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=322\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">05:22</button>\n\nStart from an empty project directory and initialize it.\n\n### Step 1 — Initialize and Install Dependencies\n\n```\nnpm init\nnpm install express\nnpm install -D @types/express\n```\n\nExpress is the production dependency. The `@types/express` package is installed as a **dev dependency** — note the separation between `dependencies` and `devDependencies` in your `package.json`.\n\n### Step 2 — Configure the Start Script and Module Type\n\nIn `package.json`, add a start script and set the module type:\n\n```\n{\n  \"type\": \"module\",\n  \"scripts\": {\n    \"start\": \"node index.js\"\n  }\n}\n```\n\nThe `\"type\": \"module\"` field is what allows you to use `import` syntax instead of `require`.\n\n### Step 3 — Write `index.js`\n\n```\nimport express from 'express';\n\nconst app = express();\nconst PORT = process.env.PORT || 8080;\n\napp.get('/', (req, res) => {\n  return res.json({ message: 'Hello From The Server' });\n});\n\napp.listen(PORT, () => {\n  console.log(`Server is up and running on PORT ${PORT}`);\n});\n```\n\nWalk through what each line does:\n- `const PORT = process.env.PORT || 8080;` — if the environment provides a port, use it; otherwise fall back to 8080. This is what makes the app portable between your laptop and a container.\n- `app.get('/', ...)` — registers one route at the root path.\n- The arrow function receives a request and returns a JSON response.\n- `app.listen` binds the server to the port and logs confirmation.\n\n### Concept Check\n\n1. Why is `@types/express` installed with the `-D` flag rather than as a regular dependency?\n2. What would happen if you removed `\"type\": \"module\"` from `package.json` but kept the `import` statement?\n3. Why read the port from `process.env.PORT` instead of hard-coding 8080?\n\n---\n\n## Part 4 — Dockerizing the Application <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=461\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">07:41</button>\n\n### The Dockerfile\n\nCreate a file named exactly `Dockerfile` — capital D, no extension.\n\n```\nFROM node:22-alpine\n\nWORKDIR /app\n\nCOPY package*.json ./\n\nRUN npm install\n\nCOPY . .\n\nEXPOSE 8080\n\nCMD [\"node\", \"index.js\"]\n```\n\n### Reading the Dockerfile Line by Line\n\n- `FROM node:22-alpine` — the base image. **Alpine images are used because they are lightweight.** A smaller base image means faster pulls and a smaller attack surface.\n- `WORKDIR /app` — sets the working directory inside the container. The name is arbitrary; `/app` is conventional.\n- `COPY package*.json ./` — copies *only* the package files first.\n- `RUN npm install` — installs dependencies.\n- `COPY . .` — now copies the rest of the source files.\n\n### Why Copy package.json Separately? Layer Caching.\n\nThis ordering is deliberate — it is **layer caching** in action.\n\nDocker caches each instruction as a layer. If `package.json` has not changed since the last build, Docker reuses the cached `npm install` layer instead of re-downloading every dependency. Your source files change constantly; your dependency list changes rarely. By copying them in separate steps, a typical code-only change skips the expensive install entirely.\n\nIf you wrote `COPY . .` before `RUN npm install`, every single source edit would invalidate the cache and force a full reinstall.\n\n### Testing the Image Locally\n\n```\ndocker build -t api .\ndocker run -it --rm -p 8080:8080 api\n```\n\nThe build command pulls the base image if it isn't present locally, then builds your application layer by layer and runs `npm install`.\n\nVerify it works:\n\n```\ncurl http://localhost:8080\n```\n\nYou should receive `Hello From The Server`. Note that Node.js containers take a moment to shut down when stopped — that is completely normal.\n\n### The Docker Compose File\n\nCreate `docker-compose.yaml` — again, the name must be exact.\n\n```\nservices:\n  app:\n    build:\n      context: .\n      dockerfile: Dockerfile\n    container_name: api\n    restart: unless-stopped\n    ports:\n      - \"8080:8080\"\n```\n\nKey fields:\n- `build.context: .` — build from the current directory, since no prebuilt image exists.\n- `restart: unless-stopped` — the restart policy. The container comes back automatically unless you deliberately stopped it.\n- `ports: \"8080:8080\"` — maps host port 8080 to container port 8080.\n\nNo `.env` file is needed for this application.\n\nRun and tear down:\n\n```\ndocker compose up -d\ndocker compose down\n```\n\nThe `-d` flag runs it detached, in the background. `down` destroys all the containers.\n\n### Concept Check\n\n1. Explain layer caching in one sentence, and state what breaks if you reorder the `COPY` instructions.\n2. What is the difference between `EXPOSE 8080` in the Dockerfile and `ports: \"8080:8080\"` in Compose?\n3. What does `restart: unless-stopped` guarantee, and what does it deliberately *not* guarantee?\n\n---\n\n## Part 5 — Pushing to GitHub and Provisioning a Server <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=758\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">12:38</button>\n\n### Getting the Code onto GitHub\n\nCreate a new public repository on GitHub, then from your project directory:\n\n```\nnpx gitignore node\ngit init\ngit add .\ngit commit -m \"initial commit\"\ngit remote add origin <your-repo-url>\ngit push -u origin main\n```\n\nThe `npx gitignore node` command generates a Node-specific `.gitignore` file — this is what keeps `node_modules` and other local artifacts out of the repository.\n\n### Two Missing Pieces\n\nAfter the push, the code is on GitHub but two critical pieces of the architecture are still missing:\n\n1. **There is no server.** The diagram requires one, and it is the most important element.\n2. **There is no GitHub Action.**\n\n### Buying a VPS\n\nYou need a server that gives you **SSH access**. For this tutorial a Hostinger private VPS is used, chosen as the cheapest widely available option; the presenter notes having used it for two years.\n\nDuring purchase you select:\n- A **KVM plan** — pricing quoted at 549 INR per month on a 24-month plan.\n- A **server location** nearest to you.\n- An **operating system.** You can pick a plain OS like Ubuntu, an OS with a control panel (CloudPanel, Dokploy, Coolify, cPanel), or a pre-installed application (n8n, WireGuard, Docker, Supabase, PostHog). For this walkthrough: **plain Ubuntu.**\n\nOwning a VPS is strongly recommended for developers — you can deploy multiple projects, experiment freely, and gain production-grade experience.\n\n### First Contact with the Server\n\nFrom the hosting dashboard you get the **IP address**, the **username** (`root`), and your **root password**. You can open a browser-based remote terminal rather than SSHing from your own machine — this creates an SSH window into the server inside the browser itself.\n\nFirst commands to run:\n\n```\nsudo apt-get update\nsudo apt-get upgrade\n```\n\nThis updates all packages and repositories.\n\n### Concept Check\n\n1. What does `npx gitignore node` protect you from accidentally committing?\n2. The lesson lists three categories of OS choice at provisioning time. Name them and state why a plain OS was chosen here.\n3. Why is SSH access the non-negotiable requirement when selecting a server for this pipeline?\n\n---\n\n## Part 6 — Installing Docker on the Server and Manual Deployment <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=1063\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">17:43</button>\n\n### Installing Docker\n\nDocker **must** be installed on this machine. Running `docker` on a fresh Ubuntu box confirms it is not there. Follow the official \"Install Docker Engine on Ubuntu\" instructions — the steps are simple: add the repository, then run the install command. Verify afterward by typing `docker` and confirming it responds.\n\n### Cloning and Running Manually\n\n```\npwd\ngit clone <your-repo-url>\ncd <repo-folder>\nls\ndocker compose up -d\n```\n\nYou can `cat` your files to confirm the code and Dockerfile arrived intact. Then from your own machine:\n\n```\ncurl http://<server-ip>:8080\n```\n\nThe response now comes from the server, not from localhost. The deployment works.\n\n### The Demonstration That Motivates Everything\n\nNow change one thing in your code — say, the message becomes `Hello From The Server V1`.\n\n**Does the server update automatically?** No.\n\nHere is the full manual sequence required to ship that one-word change:\n\n1. `git add .`\n2. `git commit -m \"changes\"`\n3. `git push`\n4. Curl the server — **still the old code.** Pushing alone changes nothing.\n5. SSH back into the server.\n6. `git pull` — manually pull the new changes.\n7. `docker compose up -d --build` — rebuild and recreate the container.\n8. Curl again — now you get `V1`.\n\nEvery one of those is a manual step. **This is the thing we are about to automate.** The `--build` flag matters: without it, Compose would restart the old image rather than rebuilding from the new source.\n\n### Concept Check\n\n1. After step 3 (`git push`), the server still serves old code. Explain why in terms of who pulls from whom.\n2. What specifically does the `--build` flag add to `docker compose up -d`, and what goes wrong if you omit it after a code change?\n3. Which of steps 1–8 above could *not* be automated, and why?\n\n---\n\n## Part 7 — Writing the GitHub Actions Workflow <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=1318\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">21:58</button>\n\n### The Required Folder Structure\n\nIn the **root** of your project you must create a folder named exactly `.github`. **You cannot name it anything else.** Inside it, create a special folder called `workflows`.\n\n```\n.github/\n  workflows/\n    deploy.yaml\n```\n\nAny YAML file you place inside `workflows` will be treated by GitHub as an Action. The file name itself is free — `deploy.yaml` is just a choice.\n\n### Building the YAML Piece by Piece\n\n**The name:**\n\n```\nname: Deploy Node.js Application to Hostinger\n```\n\n**The trigger — when should this run?**\n\n```\non:\n  push:\n    branches:\n      - main\n```\n\nThis is the literal translation of the plain-English instruction from Part 2: *whenever there is a push* — specifically to the `main` branch.\n\n**The job and its runner:**\n\n```\njobs:\n  deploy:\n    runs-on: ubuntu-latest\n```\n\nThink carefully about `runs-on`. This YAML file itself has to execute on *some* server — a server that GitHub owns. `runs-on` specifies the image for that machine. Here, `ubuntu-latest`.\n\n**Step 1 — check out the code:**\n\n```\n    steps:\n      - name: Checkout code\n        uses: actions/checkout@v4\n```\n\nThe first step is always checking out code. On whatever machine your Action is running, you need to pull your code in first. `actions/checkout@v4` is a **predefined action from the GitHub team** — you don't write it yourself, you reuse it.\n\n**Step 2 — deploy over SSH:**\n\n```\n      - name: Deploy via SSH\n        uses: appleboy/ssh-action@v1\n        with:\n          host: ${{ secrets.SSH_HOST }}\n          username: root\n          key: ${{ secrets.SSH_KEY }}\n          script: |\n            cd /root/<your-repo-folder>\n            git pull\n            docker compose up -d --build\n```\n\nThe `with` block supplies the variables the action needs:\n\n- **host** — the IP address of your server. You *could* hard-code it, but what is usually preferred is reading it from GitHub Secrets.\n- **username** — `root`. This can also go in secrets, but hard-coding is acceptable.\n- **key** — the SSH **private** key, pulled from secrets.\n- **script** — the actual commands to run on your server: `cd` into the project path, `git pull`, then `docker compose up -d --build`. Note that `npm install` is *not* needed here, because Docker handles it inside the image build.\n\n### Reading the Whole File in Plain English\n\nStripped of syntax, this file says: *check out my code, SSH into my machine, cd here, git pull, and run this.* That's it. The YAML is nothing more than the plain-English instruction list made machine-readable.\n\n### Creating Repository Secrets\n\nNavigate to your repository → **Settings** → scroll to **Secrets and variables** → **Actions**. There you can create repository secrets and environment secrets.\n\nCreate a **New repository secret** named `SSH_HOST` with your server's IP address as the value. Reference it in YAML as `${{ secrets.SSH_HOST }}`.\n\n### Concept Check\n\n1. Why must the folder be named `.github/workflows` exactly, while `deploy.yaml` can be named anything?\n2. What are the *two* different servers involved in this workflow, and which one does `runs-on` describe?\n3. Why does the deployment script omit `npm install` even though the application has dependencies?\n\n---\n\n## Part 8 — SSH Key Generation and the Trust Model <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=1650\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">27:30</button>\n\n### The Core Problem\n\nYour GitHub Action runs on GitHub's server. **That machine has no access to your machine.** To give it access, you must hand it an SSH key.\n\n### Generating the Key Pair\n\n```\nssh-keygen -t rsa -b 4096 -C \"hostinger@yourname.dev\"\n```\n\nBreaking this down:\n- `-t rsa` — key type.\n- `-b 4096` — key length in bits.\n- `-C` — a comment serving as an identity label.\n\nWhen prompted for the file location, **do not accept the default** — specify a path inside your project directory so you can find the files easily. Name it `private`. When asked for a passphrase, leave it empty.\n\nThis single command generates **two files**:\n- `private` — your **private key**\n- `private.pub` — your **public key** (anything ending in `.pub` is the public key)\n\n### Where Each Key Goes\n\nThis is the part students most often get backwards.\n\n**The public key goes on the server:**\n\n```\nls -a\ncd .ssh\nls\nvim authorized_keys\n```\n\nInside the `.ssh` folder on your server there is a file called `authorized_keys`. Paste the **public** key into it, then write and quit. Be careful to paste the public key here — not the private one.\n\n**The private key goes into GitHub Secrets:**\n\nCopy the private key and create a new repository secret named `SSH_KEY` with that content as its value.\n\n### The Resulting Trust Relationship\n\nYour workflow now references `${{ secrets.SSH_KEY }}` to authenticate, and the matching public key sits in `authorized_keys` on your server. **The GitHub Action now has access to your server.**\n\n### Critical Security Warning\n\n**Do not commit the private or public key files.** Ideally you should delete both from your project directory before committing. Only `deploy.yaml` should be pushed. Be very, very careful here — a private key committed to a public repository is a complete compromise of your server.\n\n### Concept Check\n\n1. Which key goes on the server and which goes into GitHub Secrets? State the reasoning, not just the answer.\n2. What is the purpose of the `authorized_keys` file?\n3. A student pushes their project and the build succeeds — but their private key file was included in the commit. Describe the severity and what must happen next.\n\n---\n\n## Part 9 — The Pipeline in Motion <button data-url=\"https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK&t=1829\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">30:29</button>\n\nPush the code. Refresh GitHub and open the **Actions** tab. A workflow named \"Deploy\" is running.\n\nClick into it and watch the steps execute:\n1. The code is checked out.\n2. The deploy-via-SSH step begins.\n3. `npm install` runs, the SSH connection is established, the image builds, and the commands execute successfully.\n\n**You did nothing. It is doing everything automatically.**\n\n### The Full Round Trip\n\nNow make a trivial change — alter the message to `V2 Deploy`. Then:\n\n```\ngit add index.js\ngit commit -m \"changes\"\ngit push\n```\n\nCurl the server repeatedly. For a while you still get `V1` — the GitHub Action is still running, and it deploys gradually. Then: **`V2 Deploy`.**\n\nNothing else was done by hand. Returning to the Actions tab shows another workflow run that cloned the code, pulled it, went to the server, and deployed it.\n\n### Generalizing\n\nThis pattern deploys **any kind of application** — a Next.js app, a Node app, a Python app. All you need is this script. The application language is irrelevant to the automation; only the build and run commands inside the script change.\n\n### Concept Check\n\n1. Why does the server still return `V1` for several seconds after the push completes?\n2. What would you change in `deploy.yaml` to deploy a Python application instead?\n3. Trace the full path of a single character change, from your keyboard to the HTTP response, naming every machine it passes through.\n\n---\n\n## Part 10 — Switching Sides: Designing the Platform Itself <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=FdL1C6Sjc0yZITHl&t=0\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">00:00</button>\n\nSo — how hard is it to actually design GitHub Actions? It turns out to be genuinely very hard. But the good news is that **once you see the infrastructure once, everything becomes logical.**\n\nThis design addresses the complex CI/CD system requirements that interviewers expect you to know:\n- Distributed state management\n- Secure multi-tenant compute isolation\n- Handling massive, bursty workloads\n- Streaming gigabytes of log data in real time to users' browsers\n\nThis is a very common design at companies like OpenAI, Nvidia, and GitHub itself.\n\n### The Process We Follow\n\nThis is exactly the format most interviewers expect:\n\n1. **Requirements**\n2. **Data model**\n3. **API design**\n4. **High-level design**\n5. **Deep dives** into the subtler pieces\n\nFollowing this order helps you understand the problem deeply and distinguishes you from other candidates.\n\n### Functional Requirements\n\n| Requirement | Detail |\n|---|---|\n| **Trigger workflows** | Users trigger workflows via system events — a push or a pull request — or on a schedule via cron |\n| **Execute workflows** | Parse YAML files and execute discrete jobs and steps across different operating systems |\n| **Support varied runners** | Dynamic allocation of ephemeral cloud runners across Linux, Windows, and macOS, plus customer-managed self-hosted runners |\n| **Stream logs** | Users must view logs of executing jobs in real time |\n\n### Non-Functional Requirements\n\n| Requirement | Target |\n|---|---|\n| **Scalability** | Up to 50 million workflow job executions daily; coordinate more than 2 million concurrent execution jobs at peak |\n| **Isolation & multi-tenancy** | Strict virtual boundaries. We run arbitrary, untrusted code. It must never escape host isolation, reach host metadata services, or tamper with other tenants' jobs |\n| **Low orchestration latency** | Under 2 seconds from job wait to execution for warm pools; real-time log propagation ideally under 500 ms |\n| **Strict execution semantics** | At-least-once job pickup by the runner, with exactly-once job dispatch per workflow node. Scheduler failures must not duplicate deployment steps |\n| **High availability** | 99.99% availability for orchestration control and workflow status reporting |\n\n### Why \"Exactly-Once Dispatch\" Is the Hard One\n\nRead that execution-semantics requirement again carefully, because it contains a deliberate asymmetry.\n\n**At-least-once pickup** means a runner may grab the same job twice — that's tolerated, because network partitions make it unavoidable. **Exactly-once dispatch** means the deployment step itself must only ever happen once.\n\nWhy the asymmetry? Consider what duplicate dispatch would mean in practice: a scheduler crashes mid-deploy, recovers, and re-dispatches. Your production deployment runs twice, concurrently. For a deploy step that pushes database migrations, that is catastrophic.\n\nSo the system must tolerate duplicate *attempts* while guaranteeing a single *effect*. Parts 12 and 13 show the two mechanisms that deliver this: idempotency keys in the queue, and fencing tokens on the lease.\n\n### Concept Check\n\n1. Why is \"we run arbitrary, untrusted code\" listed as a requirement rather than an implementation detail?\n2. Convert 50 million executions per day into an average per-second rate. Then compare that to the stated peak of 2 million concurrent jobs — what does the gap tell you?\n3. Explain the difference between at-least-once pickup and exactly-once dispatch using a concrete failure scenario.\n\n---\n\n## Part 11 — The Data Model: Polyglot Persistence <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=FdL1C6Sjc0yZITHl&t=194\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">03:14</button>\n\nTo handle the mixture of complex relational state and massive unstructured log data, we use a **polyglot persistence architecture** — which simply means we use several different data stores for different types of data.\n\n### Store 1 — Relational Database (PostgreSQL)\n\nThis is the **source of truth** for workflow declarations, state management, job transitions, and concurrency groups.\n\nCrucially, it gives us **ACID transactions**, which are essential for atomic state changes — for example, moving a job from `queued` to `in_progress`.\n\n#### Core Tables\n\n**`workflow_definitions`** — the static, parsed schema of a workflow configuration at a given repository commit. Contains the DAG topology, trigger event rules, and default environment metadata.\n\n**`workflow_runs`** — an active or completed execution of a workflow file. Holds workflow-level state, run metadata, and commit context.\n\n**`job_runs`** — a node within the execution DAG. Tracks dependencies via `needs`, carries a label for the target agent, and holds state: `queued`, `assigned`, `in_progress`, or `completed`, plus the execution result.\n\n**`step_runs`** — an individual execution unit inside a job, evaluated sequentially on the assigned runner agent.\n\n**`runner_instances`** — tracks registered compute workers, distinguishing platform-hosted ephemeral instances from self-hosted, persistent worker nodes.\n\n> This data model is not very complicated once you've seen it — but if you have never seen it and are asked to invent it on the spot, it can be genuinely hard. Just having seen it once puts you well ahead of the competition.\n\n### Store 2 — Message Broker (Kafka)\n\nServes as a **durable queuing layer** between the orchestrator and the compute fleet. Its purpose is simple: **decouple job scheduling from job execution.**\n\n### Store 3 — Distributed Key-Value Store (Redis)\n\nServes two primary purposes:\n1. Maintaining the mapping of active WebSocket sessions for live log viewing.\n2. Acting as a high-throughput buffer for incoming log chunks before they are flushed to durable storage.\n\n### Store 4 — Object Storage\n\nThe immutable storage layer for raw YAML workflow definitions, chunked and compressed execution logs, build artifacts, and dependency cache archives.\n\n### Store 5 — Search Index (ClickHouse)\n\nAggregates log metadata and execution metrics for fast historical queries.\n\n### Worked Reasoning — Why Not Just Use Postgres for Everything?\n\nSuppose you tried. Logs alone make this collapse. A single busy job emits log lines continuously; the system handles gigabytes of log data. Postgres is optimized for transactional correctness on relatively small, highly structured rows — not for append-only firehoses of text.\n\nMatch each store to the access pattern it is actually good at:\n\n| Data | Access pattern | Right store | Why |\n|---|---|---|---|\n| Job state transitions | Small, frequent, must be atomic | Postgres | ACID guarantees |\n| Job dispatch | High-throughput, ordered, replayable | Kafka | Durable log with partitioning |\n| Live log frames | Ephemeral, sub-second, fan-out | Redis | In-memory pub/sub |\n| Archived logs | Write-once, read-rarely, huge | Object storage | Cheap per gigabyte |\n| Log search | Read-heavy, substring/regex | ClickHouse | Columnar + indexed |\n\nThe principle: **each store is chosen for the shape of its workload, not out of preference.**\n\n### Concept Check\n\n1. Which single store is the source of truth, and what property makes it suitable?\n2. A `step_run` relates to a `job_run` which relates to a `workflow_run`. Describe that hierarchy in one sentence.\n3. Why does the design distinguish between ephemeral platform-hosted runners and persistent self-hosted runners at the *table* level?\n\n---\n\n## Part 12 — API Design <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=FdL1C6Sjc0yZITHl&t=371\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">06:11</button>\n\nThe API covers two distinct surfaces:\n1. **External** interactions with outside developers and webhooks.\n2. **Internal** control communications between orchestrators and runner agents.\n\n### External Trigger API — REST\n\n**Dispatch a workflow:**\n\n```\nPOST /repos/{owner}/{repo}/actions/workflows/{workflow_id}/dispatches\n\nBody:\n{\n  \"ref\": \"main\",\n  \"inputs\": {\n    \"environment\": \"staging\"\n  }\n}\n\nResponse: 204 No Content\n```\n\nWhy `204 No Content`? **Because everything is queued asynchronously.** We do not run the workflow at that exact moment — we accept it and return. The response body has nothing meaningful to say yet.\n\n**Get workflow run details:**\n\n```\nGET /repos/{owner}/{repo}/actions/runs/{run_id}\n\nResponse: run status, completion timestamps, job count summary\n```\n\n### Internal Orchestration API — gRPC\n\nFor internal communication we can use gRPC or HTTP long polling. We choose **gRPC** for concrete advantages:\n\n- It is a **compact binary protocol**, reducing per-chunk serialization and bandwidth overhead.\n- The `.proto` contract generates **type-safe, ready-made classes** for us to use.\n\n**`AcquireJob`** — takes a runner identity and returns a job payload. Used by runners to pull pending jobs matching their labels from the queue, without overwhelming the internal workers.\n\n**`UpdateJobStatus`** — the response is simply an acknowledgment. The runner streams execution phase updates: `setup`, `run_step`, `teardown`. Also carries **keep-alive heartbeats**, which can fire roughly every 5 seconds.\n\n**`IngestLogs`** — high-speed log ingestion. Streams timestamped chunks of stdout and stderr from the runner directly to our telemetry gateway, returning a stream acknowledgment.\n\n### Note the Direction of Control\n\nObserve something important about `AcquireJob`: the runner **pulls**. The scheduler does not push work onto runners.\n\nThis is a deliberate choice. A push model requires the scheduler to track which runners are alive, which are idle, and which have capacity — making the scheduler a bottleneck and a single point of failure. In a pull model, a runner asks for work only when it genuinely has capacity. Backpressure becomes automatic: overloaded runners simply stop asking.\n\n### Concept Check\n\n1. Why does the dispatch endpoint return `204 No Content` rather than the run result?\n2. Give two concrete advantages of gRPC over REST for the internal runner-to-orchestrator channel.\n3. What failure does a missed heartbeat signal, and what should the scheduler do about it?\n\n---\n\n## Part 13 — High-Level Design <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=FdL1C6Sjc0yZITHl&t=525\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">08:45</button>\n\n### Stage 1 — Ingress\n\nAn **external event** — a Git push or webhook — kicks off the entire flow.\n\nIt hits the **Edge API Gateway pool**, which must:\n- Terminate TLS\n- Verify Git webhook signatures\n- Apply per-tenant rate limits\n- Store raw event payloads into Kafka\n\n### Stage 2 — The Shock Absorber\n\nThe **`workflow_triggers` Kafka topic** acts as an ingestion shock absorber. We may face a sudden flood of commits from large organizations or automated bots.\n\nPartitions are keyed by **hash of repo ID** — this ensures event ordering is preserved per repository, which is critical.\n\n### Stage 3 — Parse and Compile\n\nThe **ingestion and parser service** pulls events from Kafka, fetches the workflow YAML from the repository tree, validates the syntax, then expands matrix build dimensions — allowing one job definition to cover many environments.\n\nThe **DAG compiler** then translates job dependencies into an execution graph and verifies the graph is acyclic. A Directed Acyclic Graph is simply a set of nodes connected by one-way edges with no cycles.\n\n### Stage 4 — The Workflow Engine (State Machine)\n\nThis is the **central orchestrator**. It:\n- Commits the entire execution plan to Postgres in a **single ACID transaction**, marking root jobs `queued` and dependent jobs `pending`.\n- Inserts queued job records into an **outbox** table.\n\n#### The Transactional Outbox Pattern\n\nWe write the job record **in the same database transaction that causes the state change** — guaranteeing both commit together or both roll back together. **This is extremely important.**\n\nWhy? Without it, you could commit the state change and then crash before publishing the message — or publish the message and then fail to commit. Either way the system becomes inconsistent. The outbox makes \"change state\" and \"announce the change\" a single atomic fact.\n\n### Stage 5 — The Queue Distributor\n\nThe queue distributor reads Postgres's **write-ahead log** via log-based CDC (Change Data Capture).\n\nIt applies **backpressure** using `ZCARD`: the scheduler counts active jobs in a group using Redis and refuses to dispatch more once the group reaches its limits.\n\nIt then pushes ready jobs into **Redis sorted sets**, which avoids double writes from the workflow engine and enables clean queue rebuilding during disaster recovery.\n\n### Stage 6 — Priority Job Queues in Redis\n\nPending jobs are organized into separate sorted sets, **partitioned by capability** — one for Linux, one for ARM, one for GPU — plus a **unique job ID** that acts as an **idempotency key preventing duplicate entries during retries.**\n\n### Stage 7 — Ephemeral Micro-VM Runners\n\nThese are warm worker environments that pull jobs from their matching label queue via the **atomic `ZPOPMAX` work-stealing mechanism.**\n\nThe key outcome: **fast, ordered job distribution with no duplicate execution and no central scheduler bottleneck.**\n\nThe runner acquires an **execution lease** in Postgres with an **incrementing fencing token**, launches the user step inside an isolated Micro-VM, and streams terminal output over gRPC.\n\n### Stage 8 — Telemetry Ingestion and Log Fan-Out\n\nThe **telemetry ingestion gateway** is a **stateless reverse proxy** that splits the incoming gRPC stream into two dedicated paths:\n\n**Path A — Live viewing:** Publishes terminal chunks directly to **Redis pub/sub**, which distributes frames to the **WebSocket gateway**, streaming live logs over persistent socket connections to web console clients with **under 500 ms latency and zero database or disk load.**\n\n**Path B — Durable:** Sends data to the **`runner_logs` Kafka topic**, partitioned by hash of job run ID to guarantee monotonic line ordering per job.\n\nTwo independent consumer groups read concurrently from `runner_logs`:\n- **S3 workers** — buffer chunks up to 5–10 MB or 60 seconds, then perform multipart uploads of Zstandard-compressed files to object storage for long-term durable retention.\n- **ClickHouse ingestion workers** — micro-batch logs every 1–2 seconds directly into the ClickHouse cluster, indexing line offsets and tokenized text for fast regex substring search.\n\n### Stage 9 — Terminal State Notifications\n\nThis path asynchronously decouples internal and external systems from the core scheduling database transaction.\n\nA **Debezium CDC connector** tracks the Postgres write-ahead log for changes in job and workflow run state, then publishes unified state-change events to a **`workflow_events` Kafka topic**.\n\nTwo consumers:\n- **Notification service** — consumes state events to update GitHub pull request commit check icons (pending, failed, successful) and send outbound customer-configured webhooks or email.\n- **Billing and metering service** — consumes job completion events and aggregates CPU runtime seconds to track organizational usage quota and compute billing overages.\n\n### Concept Check\n\n1. Why is the Kafka trigger topic partitioned by repo ID hash rather than randomly?\n2. Explain the transactional outbox pattern and the specific failure it prevents.\n3. The telemetry gateway is described as \"stateless.\" What does statelessness buy you when a gateway node restarts?\n4. Trace a single log line from the runner's stdout to a user's browser tab, naming each component.\n\n---\n\n## Part 14 — Deep Dive: Workflow Orchestration with DAGs <button data-url=\"https://youtu.be/nKUe1ML_zhE?si=FdL1C6Sjc0yZITHl&t=870\" className=\"youtube_timestamp\" style=\"background-color:#DEF1FF;color:#065FD7;border:none;padding:5px 7px;font-size:9px;cursor:pointer;vertical-align:middle;margin-left:8px;\">14:30</button>\n\n### From YAML to Graph\n\nStart with the familiar YAML job specification. Suppose we have three jobs: `test`, `build`, and `deploy`, with `needs` declarations creating dependencies.\n\nVisualize this as a Directed Acyclic Graph:\n\n```\ntest  →  build  →  deploy\n```\n\n`build` needs `test`; `deploy` needs `build`. This gives us a linear flow.\n\n### Data Structure 1 — The Adjacency List\n\nAn adjacency list tracks the nodes and edges:\n\n| Node | Successors |\n|---|---|\n| test | build |\n| build | deploy |\n| deploy | *(none)* |\n\n### Data Structure 2 — In-Degree State\n\nThe in-degree counts **how many things a job depends on**:\n\n| Node | In-degree |\n|---|---|\n| test | 0 |\n| build | 1 |\n| deploy | 1 |\n\n`test` depends on nothing, so zero. `build` depends on `test`, so one. `deploy` depends on `build`, so one.\n\n### The Scheduling Rule\n\nJobs begin in a `pending` state, **blocked by their upstream dependencies**.\n\n> **A job may move from `pending` to `queued` exactly when all parent dependencies are satisfied and its in-degree reaches zero.**\n\nIn our example: `test` starts immediately as `queued`, while `build` and `deploy` start as `pending`.\n\n### The Full State Machine\n\n```\npending ──(in-degree reaches 0)──► queued\nqueued  ──(worker leases it)─────► assigned\nassigned ──(first heartbeat)─────► in_progress\nassigned ──(startup crash)───────► queued        [retry]\nin_progress ──(lease timeout)────► queued        [retry]\nin_progress ──(success)──────────► completed     [unblocks dependents]\nin_progress ──(failure)──────────► failed\ndependent of failed job ─────────► cancelled / skipped\n```\n\nWalking the transitions:\n- Once a job is queued, a **worker leases it** → state becomes `assigned`.\n- If runner startup crashes or anything else goes wrong, the job **returns to queued** for another worker to lease.\n- With no fault, the job moves from `assigned` to `in_progress` **on receipt of the first verification heartbeat**.\n- If the **lease times out or a heartbeat is lost**, the job returns to queued and starts over.\n- On **success**, it unblocks its associated dependents — once `test` succeeds, `build` moves from `pending` to `queued`.\n- On **failure**, downstream jobs are cancelled and marked `cancelled` or `skipped`.\n\n### Worked Example — Executing a Diamond DAG\n\nThe linear case is easy. Consider instead:\n\n```\n        ┌─► lint ──┐\ntest ───┤          ├─► deploy\n        └─► build ─┘\n```\n\nIn-degrees: `test` = 0, `lint` = 1, `build` = 1, `deploy` = 2.\n\n**",
          "file_uploads": [],
          "files": [
            {
              "title": "GitHub Actions Tutorial - Deploy Node.js Application with CI CD and GitHub Actions",
              "url": "https://youtu.be/y7S2oSjJ8PA?si=36ENBdVzBjUaZMwK",
              "type": "yt_link",
              "source": "yt_link"
            }
          ]
        }
      ];

      const histories = historiesData
      // const histories = demo
        .map((item, index) => {
          try {
            return {
              uuid: item.uuid ?? crypto.randomUUID(),
              query: String(item.query).trim(),
              answer: normalizeLatexToDoubleDollar(item?.answer),
              file: [...item.files] ?? [],
            };
          } catch (err) {
            // Security: separate dynamic data from format string
            console.error("Failed to process history item", index, ":", err);
            return null;
          }
        })
        .filter(Boolean);

      if (payload?.lesson_id) {
        if (response?.data?.data?.room_id) {
          setRoom_id(response?.data?.data?.room_id);
          sessionStorage.setItem("roomId", response?.data?.data?.room_id);
        } else {
          getUserId().then((user_id) => {
            if (user_id !== null) {
              createChatRoom(user_id).then((roomId) => {
                if (roomId !== "") {
                  setRoom_id(roomId);
                  sessionStorage.setItem("roomId", roomId);
                }
              });
            }
          });
        }
      }

      setChatHist(histories);
    } catch (error) {
      toast.error("Failed to load lesson history");
      console.error("callchathistfunction error:", error);
    } finally {
      // Every exit path counts as "done loading" — an early return or a failed
      // request must not leave the empty state permanently suppressed.
      setIsChatHistLoading(false);
    }
  };
  const getUserId = async () => {
    if (token) {
      try {
        const response = await api.get(`auth/get-user-id/`, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        });
        if (response.status === 200 || response.status === 201) {
          updateState("user_id", response?.data?.user_id);
          return response?.data?.user_id;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    }
  };
  const getRubric = async (lesson_id, assignment_data) => {
    await api
      .get(`assignments/get-rubric-by-lesson-id/${lesson_id}/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })

      .then((response) => {
        if (response.status === 200) {
          const getAssignmentIds = assignment_data.map((val) => val.rubric_id);
          const get_rubics = response?.data?.data;
          const rubricOrders = [];

          for (let i = 0; i < getAssignmentIds.length; i++) {
            if (getAssignmentIds[i] === null) {
              const arr = {
                data: '<p class="editor-paragraph" dir="ltr"> <b><strong class="editor-text-bold" style="white-space: pre-wrap;">This Rubric is generated by the system</strong></b></p>',
                Id: null,
              };
              rubricOrders.push(arr);
            } else {
              for (let j = 0; j < get_rubics.length; j++) {
                if (getAssignmentIds[i] === get_rubics[j].rubric_id) {
                  const arr = {
                    data: get_rubics[j].rubric,
                    Id: get_rubics[j].rubric_id,
                  };
                  rubricOrders.push(arr);
                  break;
                }
              }
            }
          }
          setRubrics(rubricOrders);

          const rubricLog = get_rubics?.map((item) => item?.rubric).join("  ");
          updateWorkboardDataByName(workboards.RUBRIC.name, rubricLog);
          const getid = get_rubics?.length > 0 ? get_rubics[0]?.rubric_id : "";
          setrubric_id(getid);

          const rubricIdsOrdered = rubricOrders.map((row) => row.Id) || [];
          sessionStorage.setItem("Rubric_id", JSON.stringify(rubricIdsOrdered));

          const newArray = get_rubics.map((item) => {
            return {
              data: item.rubric,
              Id: item.rubric_id,
            };
          });

          const globleSaveData = JSON.parse(
            sessionStorage.getItem("GlobleSaveData"),
          );
          const globleOnChange = JSON.parse(
            sessionStorage.getItem("globleOnChangeData"),
          );

          globleSaveData.RUBRIC.data = rubricOrders;
          globleOnChange.RUBRIC.data = rubricOrders;

          setGlobleOnChange(globleOnChange);
          setGlobleSaveData(globleSaveData);

          sessionStorage.setItem(
            "GlobleSaveData",
            JSON.stringify(globleSaveData),
          );
          sessionStorage.setItem(
            "globleOnChangeData",
            JSON.stringify(globleOnChange),
          );
        }
      })
      .catch((error) => { });
  };

  const getAssignment = async (lesson_id) => {
    await api
      .get(
        `assignments/get-assignments-by-lesson/${lesson_id}/?sort=Oldest&fetch_all=true
`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          setGetAssignmentdetails(response?.data?.data);

          if (
            response?.data?.data?.length > 0 &&
            !location.state?.assignment &&
            !location.state?.openFirstAssignment
          ) {
            setSelectedAssignment(`Assignment ${response?.data?.data?.length}`);
          }

          // alert(response?.data?.data[assignmentsCountTwo].synced_with_schoology);
          // setassignmentschoologystatus(response?.data?.data[assignmentsCountTwo].synced_with_schoology);

          const rubricLessonId =
            lesson_id ??
            lesson?.lesson_id ??
            lesson?.Id ??
            (() => {
              try {
                const details = JSON.parse(
                  sessionStorage.getItem("lessonDetails") || "{}",
                );
                return details.Id ?? details.lesson_id;
              } catch {
                return undefined;
              }
            })();

          if (rubricLessonId) {
            getRubric(rubricLessonId, response?.data?.data);
          }
          const get_assignment = response?.data?.data;
          const assignmentsLog = get_assignment
            ?.map((item) => item?.assignment)
            .join("  ");
          updateWorkboardDataByName(workboards.ASSIGNMENT.name, assignmentsLog);
          const getid =
            get_assignment?.length > 0 ? get_assignment[0]?.assignment_id : "";

          if (get_assignment?.length > 0) {
          }

          setassignment_id(getid);

          const assignmentIds =
            get_assignment?.map((item) => item.assignment_id) || [];
          sessionStorage.setItem(
            "Assingment_Id",
            JSON.stringify(assignmentIds),
          );

          const rubricIds = get_assignment?.map((item) => item.rubric_id) || [];
          sessionStorage.setItem("Rubric_id", JSON.stringify(rubricIds));

          const assignmentdatadetails =
            get_assignment?.map((item) => item.assignment) || [];

          let getNewArray = [];
          get_assignment.map((item) => {
            getNewArray.push(item.assignment);
          });

          if (location.state?.assignment?.assignment) {
            const assignmentIndex = response?.data?.data.findIndex(
              (item) =>
                item.assignment === location.state?.assignment?.assignment,
            );

            // Set to first assignment
            setAssignmentCountsTwo(assignmentIndex);
            setSelectedAssignment(`Assignment ${assignmentIndex + 1}`);
            setActiveWorkboard(workboards.ASSIGNMENT);
            setIsAssignment(true);
            setIsRubric(false);
            setEachAssignment_id(location.state?.assignment?.assignment_id);
            setassignment_id(location.state?.assignment?.assignment_id);
            setPreviesAssignment(true);
            setPopupVisible(false);

            // Set sync status
            if (
              getassignmentdetails[assignmentIndex]?.synced_with_schoology !==
              undefined
            ) {
              setswitchschoologySync(
                getassignmentdetails[assignmentIndex].synced_with_schoology,
              );
            }
          }

          const newArray = get_assignment.map((item) => {
            return {
              data: item.assignment,
              Id: item.assignment_id,
            };
          });
          const newFormAssignmentArrya = get_assignment.map((item) => {
            return {
              name: item.name,
              assignment: null,
              assignment_json: null,
              lesson: null,
              duration_minutes: item.duration_minutes,
              start_date: item.start_date,
              end_date: item.end_date,
              type: item.type,
            };
          });

          const globleSaveData = JSON.parse(
            sessionStorage.getItem("GlobleSaveData"),
          );
          const globleOnChange = JSON.parse(
            sessionStorage.getItem("globleOnChangeData"),
          );
          globleSaveData.ASSIGNMENT.data = newArray;
          globleSaveData.ASSIGNMENT.formSaveAssignment = newFormAssignmentArrya;
          globleOnChange.ASSIGNMENT.data = getNewArray;
          globleOnChange.ASSIGNMENT.formAssignment = newFormAssignmentArrya;

          setGlobleOnChange(globleOnChange);
          setGlobleSaveData(globleSaveData); //bb

          if (globleSaveData.ASSIGNMENT.formSaveAssignment.length > 0) {
            setFormAssignmentState((prevState) => ({
              ...prevState,
              name: globleSaveData.ASSIGNMENT.formSaveAssignment[0].name,
              duration_minutes:
                globleSaveData.ASSIGNMENT.formSaveAssignment[0]
                  .duration_minutes,
              start_date: dayjs().format("YYYY-MM-DD"),
              type: globleSaveData.ASSIGNMENT.formSaveAssignment[0].type,
              end_date:
                globleSaveData.ASSIGNMENT.formSaveAssignment[0].end_date,
            }));
          }

          sessionStorage.setItem(
            "GlobleSaveData",
            JSON.stringify(globleSaveData),
          );
          sessionStorage.setItem(
            "globleOnChangeData",
            JSON.stringify(globleOnChange),
          );
        }
      })
      .catch((error) => { });
  };

  const getAssignmentRef = useRef(null);
  const getRubricRef = useRef(null);
  getAssignmentRef.current = getAssignment;
  getRubricRef.current = getRubric;

  useEffect(() => {
    registerGenerateAllRefetchCallbacks?.({
      afterCreateAssignment: async (lid) => {
        if (!lid) return;
        await getAssignmentRef.current?.(lid);
      },
      afterCreateRubric: async (lid) => {
        if (!lid) return;
        const response = await api.get(
          `assignments/get-assignments-by-lesson/${lid}/?sort=Oldest&fetch_all=true`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Token ${token}`,
            },
          },
        );
        if (response.status === 200 && response?.data?.data) {
          await getRubricRef.current?.(lid, response.data.data);
        }
      },
    });
    return () => registerGenerateAllRefetchCallbacks?.(null);
  }, [registerGenerateAllRefetchCallbacks, token]);

  useEffect(() => {
    if (lesson?.description === GENERATE_LESSON_DESCRIPTION_PLACEHOLDER) {
      // const roomid_saved = sessionStorage.getItem("roomId");
      // if (roomid_saved) {
      //   getChatHistorybyRoomid(roomid_saved);
      // }
      // getUserId().then((user_id) => {
      //   if (user_id !== null && roomid_saved == null) {
      //     createChatRoom(user_id).then((roomId) => {
      //       if (roomId !== "") {
      //         setRoom_id(roomId);
      //       }
      //     });
      //   }
      // });
      getChatHistory(lesson?.lesson_id);
    } else {
      sessionStorage.setItem("GlobleSaveData", JSON.stringify(globleSaveData));
      sessionStorage.setItem(
        "globleOnChangeData",
        JSON.stringify(globleOnChange),
      );

      getChatHistory(lesson?.lesson_id);
      getAssignment(lesson?.lesson_id);
      // getLeson(lesson?.lesson_id);
    }
  }, []);

  const generateRandomNumber = () => {
    const randomNum = Math.floor(10000000 + Math.random() * 90000000); // Ensures the number is 8 digits
    return randomNum;
  };

  useEffect(() => {
    const randomNum = generateRandomNumber();
    sessionStorage.setItem("RandomNumber", randomNum);
  }, []);

  useEffect(() => {
    if (lesson?.description !== GENERATE_LESSON_DESCRIPTION_PLACEHOLDER) {
      const getData = JSON.parse(sessionStorage.getItem("lessonDetails"));

      updateDefaultWorkboardData(
        defaultWorkboardData.LESSON.name,
        getData
          ? lesson.description !== getData.data
            ? getData.data
            : getData.data
          : lesson.description,
      );

      updateWorkboardDataByName(
        workboards.LESSON.name,
        getData
          ? lesson.description !== getData.data
            ? getData.data
            : getData.data
          : lesson.description,
      );
    }
  }, [lesson?.description]);

  //it is for setting the default first assignment. when we come from edit assignmet

  useEffect(() => {
    if (location.state?.openFirstAssignment) {
      /**
       * The flag rides in on sessionStorage (`previewLessonData`), not history
       * state, so it is still set after a refresh. Auto-creating + generating
       * the first assignment is a one-shot navigation intent: without this
       * marker every reload of the skip-lesson flow kicks off a fresh
       * generation, and on a cold mount the lesson socket isn't up yet, so it
       * dies on "Connection lost. Please try again.".
       * sessionStorage is per-tab and both entry points open a new tab, so the
       * marker can never block a later legitimate navigation.
       */
      const autoFirstAssignmentKey = `autoFirstAssignmentDone:${location.state?.lesson?.lesson_id ?? "new"}`;

      // Set to first assignment
      setAssignmentCountsTwo(0);
      setSelectedAssignment("Assignment 1");
      setActiveWorkboard(workboards.ASSIGNMENT);
      setIsAssignment(true);
      setIsRubric(false);

      // Load first assignment data
      const globleOnChangeData = JSON.parse(
        sessionStorage.getItem("globleOnChangeData"),
      );
      if (globleOnChangeData?.ASSIGNMENT?.data?.[0]) {
        const firstAssignmentData = globleOnChangeData.ASSIGNMENT.data[0];

        // Set assignment ID
        if (globleSaveData.ASSIGNMENT.data[0]?.Id) {
          setEachAssignment_id(globleSaveData.ASSIGNMENT.data[0].Id);
          setassignment_id(globleSaveData.ASSIGNMENT.data[0].Id);
          setPreviesAssignment(true);
          setPopupVisible(false);
        }

        // Set sync status
        if (getassignmentdetails.length > 0) {
          if (getassignmentdetails[0]?.synced_with_schoology !== undefined) {
            setswitchschoologySync(
              getassignmentdetails[0].synced_with_schoology,
            );
          }
        } else {
          setswitchschoologySync(false);
        }
      } else if (!sessionStorage.getItem(autoFirstAssignmentKey)) {
        sessionStorage.setItem(autoFirstAssignmentKey, "true");
        setCallAddAssignmentFun(true);
      }
    }
  }, [location.state?.openFirstAssignment, getassignmentdetails.length]);

  useEffect(() => {
    const skipLessonStatus = sessionStorage.getItem("skipLesson") === "true";
    setAssignmentgeneration(skipLessonStatus); // Disable assignment if lesson is skipped
  }, []);

  useEffect(() => {
    if (!isSwitchOn) {
      setShowPopup(false); // Hide the popup when the switch is turned on
    }
  }, [isSwitchOn]);

  useEffect(() => {
    sessionStorage.setItem(
      "globleOnChangeData",
      JSON.stringify(globleOnChange),
    );
  }, [globleOnChange]);

  useEffect(() => {
    if (globleSaveData[activeWorkboard.name.toLocaleUpperCase()].data) {
      sessionStorage.setItem("GlobleSaveData", JSON.stringify(globleSaveData));
    }
  }, [globleSaveData]);

  useEffect(() => {
    const getData = JSON.parse(sessionStorage.getItem("lessonDetails"));

    if (
      lesson?.description === GENERATE_LESSON_DESCRIPTION_PLACEHOLDER &&
      sessionStorage.getItem("skiplesson") == false
    ) {
      if (getData && getData.data !== "") {
        getChatHistory(getData.Id);
        getAssignment(getData.Id);
        const lessonDeta = {
          description:
            getData.data === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two
              ? ""
              : getData.data,
          lesson_id: getData.Id,
        };

        setLesson(lessonDeta);
        setlesson_id(getData.Id);

        updateDefaultWorkboardData(
          defaultWorkboardData.LESSON.name,
          getData.data,
        );
        updateWorkboardDataByName(workboards.LESSON.name, getData.data);
        setFormState((prev) => ({ ...prev, description: getData.data }));
        const globleSaveData = JSON.parse(
          sessionStorage.getItem("GlobleSaveData"),
        );
        const globleOnChange = JSON.parse(
          sessionStorage.getItem("globleOnChangeData"),
        );

        const newLessonArrya = {
          data: {
            data: getData.data,
            Id: getData.Id,
          },
        };

        globleSaveData.LESSON.data = newLessonArrya;
        globleOnChange.LESSON.data = newLessonArrya;

        sessionStorage.setItem(
          "GlobleSaveData",
          JSON.stringify(globleSaveData),
        );
        sessionStorage.setItem(
          "globleOnChangeData",
          JSON.stringify(globleOnChange),
        );
      }
    } else {
      if (getData && getData.data !== "") {
        if (lesson?.description !== getData.data) {
          getChatHistory(getData.Id);
          getAssignment(getData.Id);
          const lessonDeta = {
            description:
              getData.data === EMPTY_LESSON_PLACEHOLDER_DESCRIPTION_two
                ? ""
                : getData.data,
            lesson_id: getData.Id,
          };

          setLesson(lessonDeta);
          setlesson_id(getData.Id);

          updateDefaultWorkboardData(
            defaultWorkboardData.LESSON.name,
            getData.data,
          );
          updateWorkboardDataByName(workboards.LESSON.name, getData.data);
          setFormState((prev) => ({ ...prev, description: getData.data }));
          const globleSaveData = JSON.parse(
            sessionStorage.getItem("GlobleSaveData"),
          );
          const globleOnChange = JSON.parse(
            sessionStorage.getItem("globleOnChangeData"),
          );

          const newLessonArrya = {
            data: {
              data: getData.data,
              Id: getData.Id,
            },
          };

          globleSaveData.LESSON.data = newLessonArrya;
          globleOnChange.LESSON.data = newLessonArrya;

          sessionStorage.setItem(
            "GlobleSaveData",
            JSON.stringify(globleSaveData),
          );
          sessionStorage.setItem(
            "globleOnChangeData",
            JSON.stringify(globleOnChange),
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    // localStorage.setItem("GlobleSaveData", JSON.stringify(globleSaveData));
    // localStorage.setItem("globleOnChangeData", JSON.stringify(globleOnChange));

    if (
      location.state?.lesson !== undefined &&
      location.state?.lesson.description !==
      GENERATE_LESSON_DESCRIPTION_PLACEHOLDER
    ) {
      const getData = JSON.parse(sessionStorage.getItem("lessonDetails"));

      const globleSaveData = JSON.parse(
        sessionStorage.getItem("GlobleSaveData"),
      );
      const globleOnChange = JSON.parse(
        sessionStorage.getItem("globleOnChangeData"),
      );

      const youtubeUrl = extractYoutubeUrlFromHtml(
        location.state?.lesson.description,
      );
      setGetSavedYoutubeLinks(youtubeUrl);

      const newLessonArrya = {
        data: {
          data: getData
            ? location.state?.lesson.description !== getData.data
              ? getData.data
              : getData.data
            : location.state?.lesson.description,
          Id: getData
            ? location.state?.lesson.lesson_id !== getData.Id
              ? getData.Id
              : getData.Id
            : location.state?.lesson.lesson_id,
        },
      };

      globleSaveData.LESSON.data = newLessonArrya;
      globleOnChange.LESSON.data = newLessonArrya;

      sessionStorage.setItem(
        "lessonDetails",
        JSON.stringify({
          data: getData
            ? location.state?.lesson.description !== getData.data
              ? getData.data
              : getData.data
            : location.state?.lesson.description,
          Id: getData
            ? location.state?.lesson.lesson_id !== getData.Id
              ? getData.Id
              : getData.Id
            : location.state?.lesson.lesson_id,
        }),
      );
      sessionStorage.setItem("GlobleSaveData", JSON.stringify(globleSaveData));
      sessionStorage.setItem(
        "globleOnChangeData",
        JSON.stringify(globleOnChange),
      );
    }
  }, [location.state?.lesson]);

  const [hideRubricPopUp, setHideRubricPopUp] = useState(false);

  useEffect(() => {
    if (!istoggleClick) {
      if (getassignmentdetails.length > 0) {
        const initialArray = new Array(getassignmentdetails.length)
          .fill("")
          .map((_, index) => `Assignment ${index + 1}`);

        setAssignmentCounts(initialArray);
        setOnChangeAssignmentData(
          getassignmentdetails
            .filter((item) => item && item.assignment) // Only keep items that have 'assignment' property
            .map((item) => item.assignment), // Map only valid items
        );
      }
    }
  }, [getassignmentdetails]);

  useEffect(() => {
    if (rubrics.length > 0) {
      setSelectedRubric(`Rubric ${rubrics.length}`);
      const initialArray = new Array(rubrics.length)
        .fill("")
        .map((_, index) => `Rubric ${index + 1}`);
      setRubricCount(initialArray);
      // setAssignmentCountsTwo(initialArray.length)
      setOnChangeRubricData(rubrics?.map((item) => item.data));
    }
  }, [rubrics]);

  const stripHtmlTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  useEffect(() => {
    if (activeWorkboard.name === "Assignment") {
      setWorkboardText(stripHtmlTags(workboards.ASSIGNMENT.data).trim());
    } else if (activeWorkboard.name === "Rubric") {
      setWorkboardText(stripHtmlTags(workboards.RUBRIC.data).trim());
    } else {
      setWorkboardText(stripHtmlTags(workboards.LESSON.data).trim());
    }
  }, [workboards]);

  useEffect(() => {
    const globleOnChangeData = JSON.parse(
      sessionStorage.getItem("globleOnChangeData"),
    );

    if (
      globleOnChangeData.ASSIGNMENT.data.length >
      globleOnChangeData.ASSIGNMENT.formAssignment.length
    ) {
      const newFormAssignmentArrya = {
        name: formAssignmentState.name,
        assignment: null,
        assignment_json: null,
        lesson: null,
        duration_minutes: formAssignmentState.duration_minutes,
        start_date: formAssignmentState.start_date,
        end_date: formAssignmentState.end_date,
        type: formAssignmentState.type,
      };

      const globleOnChange = JSON.parse(
        sessionStorage.getItem("globleOnChangeData"),
      );

      const globleOnChangeUpdateFormAssignment =
        globleOnChange.ASSIGNMENT.formAssignment;
      globleOnChangeUpdateFormAssignment.push(newFormAssignmentArrya);

      globleOnChange.ASSIGNMENT.formAssignment =
        globleOnChangeUpdateFormAssignment;

      setGlobleOnChange(globleOnChange);

      sessionStorage.setItem(
        "globleOnChangeData",
        JSON.stringify(globleOnChange),
      );
    } else {
      const newFormAssignmentArrya = {
        name: formAssignmentState.name,
        assignment: null,
        assignment_json: null,
        lesson: null,
        duration_minutes: formAssignmentState.duration_minutes,
        start_date: formAssignmentState.start_date,
        end_date: formAssignmentState.end_date,
        type: formAssignmentState.type,
      };
      const globleOnChange = JSON.parse(
        sessionStorage.getItem("globleOnChangeData"),
      );

      const globleOnChangeUpdateFormAssignment =
        globleOnChange.ASSIGNMENT.formAssignment;

      globleOnChangeUpdateFormAssignment[assignmentsCountTwo] =
        newFormAssignmentArrya;
      globleOnChange.ASSIGNMENT.formAssignment =
        globleOnChangeUpdateFormAssignment;

      setGlobleOnChange(globleOnChange);

      sessionStorage.setItem(
        "globleOnChangeData",
        JSON.stringify(globleOnChange),
      );
    }
  }, [activeWorkboard.name]);

  //bb
  useEffect(() => {
    const globleOnChangeData = JSON.parse(
      sessionStorage.getItem("globleOnChangeData"),
    );
    if (globleOnChangeData) {
      const workboardName = activeWorkboard.name.toUpperCase();

      updateWorkboardDataByName(
        globleOnChangeData[workboardName].name,
        globleOnChangeData[workboardName].data,
      );
    }
  }, [activeWorkboard.name]);

  // Event listener to close modal if clicked outside the modal content
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target)
      ) {
        toggledownlodefile();
      }
    };

    // Attach the event listener
    if (showDownloadFile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDownloadFile]);

  useEffect(() => {
    AOS.init({
      duration: 500,
    });
  }, []);

  useEffect(() => {
    sessionStorage.setItem("assignmentDurationCount", assignmentDurationCount);

    return () => {
      sessionStorage.setItem("assignmentDurationCount", 0);
    };
  }, [assignmentDurationCount]);

  //bb:26-06-2025 implemented code
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("lesson_formState");
      sessionStorage.removeItem("lessonDetails");
    };
  }); //bb: removing because it is taking the existing data only : so if i renove this then it wiill map current lessonname , lesson date

  useEffect(() => {
    // Save the form state to local storage whenever it changes
    sessionStorage.setItem("lesson_formState", JSON.stringify(formState));
    // localStorage.setItem("lessonDetails", JSON.stringify(formState.description));
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isListening) {
        if (event.key) {
          startStopListening();
        }
      }
    };
    // Adding the event listener when the component mounts or stopListeningBTN changes
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isListening, transcript]);

  useEffect(() => {
    return () => {
      dispatch(resetLessonAudio());
      dispatch(resetReFormatter());
    };
  }, []);

  return (
    <>
      {" "}
      <LessonGenerator />
      {openStudentView && (
        <div className="preview-student-wrapper">
          <div
            style={{ padding: "30px 20px" }}
            className="Course-created-successfully-container"
          >
            {/* dismiss modal */}
            <div
              className="close-modal-btn-student-view"
              onClick={() => setopenStudentView(false)}
            >
              <a href="#!">
                <i className="fa-solid fa-xmark dismis-close"></i>
              </a>
            </div>

            <div
              style={{ height: "482px", zIndex: 999, overflow: "auto" }}
              className="Course-created-successfully-folder"
            >
              <h4>
                {isAssignment ? "Assignment" : isRubric ? "Rubric" : "Lesson"}
              </h4>
              <div ref={previewBodyRef}>
                {previewYoutubeEmbedSrc !== "" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "20px 0",
                    }}
                  >
                    <iframe
                      ref={previewYoutubeIframeRef}
                      width="560"
                      height="315"
                      src={previewYoutubeEmbedSrc}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    />
                  </div>
                )}
                <PreprocessAndRenderLatex
                  content={
                    isGenerateLessonDescriptionPlaceholder
                      ? ""
                      : previewCleanHtml
                  }
                  isBlockMath={false}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="rubric-popup-wrapper"
        style={{
          display: showRubricPopUp && !hideRubricPopUp ? "flex" : "none",
        }}
      >
        <div className="rubric-popup-container">
          <h2>
            In the absence of a teacher-created rubric, the system will generate
            a default one.
          </h2>
          <button
            type="button"
            className=""
            onClick={() => setHideRubricPopUp(true)}
          >
            Continue
          </button>
        </div>
      </div>
      {!adminRole && (
        <FloatingAIButton
          onClick={() => {
            const agentData = [
              {
                key: course?.name || "Course",
                value: String(course?.course_id || ""),
              },
            ];

            dispatch(setAgentData(agentData));
            if (course?.course_id) {
              dispatch(setInitialProjectId(String(course?.course_id)));
            }
            dispatch(setDrawerState(!chatDrawerState.isOpen));
            dispatch(setIsWebAllowed(true));
            dispatch(setQueryMetaData(null));
          }}
        />
      )}
      {showPopUp && (
        <>
          <form
            action=""
            className="Course-created-successfully-form"
            id="schoology-Course-created-successfully-form"
          >
            <div
              className="schoology-Course-created-successfully-container"
              data-aos="zoom-in"
            >
              <h2>
                {assignmentMsg
                  ? "Once saved, your course will be synced automatically."
                  : "Once saved, your assignment will be synced automatically."}
              </h2>
              {/* { loadingPopUp ? <h2> Please wait...</h2> : <h2>Course unavailable on Schoology. Would you like to create it?</h2> } */}
              <div className="schoology-Course-created-successfully-container-btn-folder">
                {loadingPopUp ? (
                  // <div className="loading-spinner" />
                  <Ring />
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={handleNoClick}
                      disabled={loadingPopUp}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={handleYesClick}
                      className="create-btn"
                    >
                      {loadingPopUp ? (
                        <Ring size={20} lineWeight={5} speed={2} color="#fff" />
                      ) : (
                        "Confirm Sync"
                      )}
                    </button>
                  </>
                )}
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default NewLessonsEntry;
